/**
* @GasInfoTable.vue
* @Description
* @Author JiShaoHua
* @Date 2022/10/21 15:21
**/
<template>
  <div class="table-item-box _padding-l-none" style="padding: 10px;">
    <section style="height: 100%;">
      <!-- 表格 -->
      <el-table :data="sensorInfos"
                @sort-change="changeSort"
                ref="multipleTable"
                stripe
                style="width: 100%;margin-bottom: 10px;height: calc(100% - 90px);"
                :class="{'table': true, 'no-pagination': false}">
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="传感器类型" min-width="100px" :sortable="filters.sortable" prop="sensor_type" :sort-orders="filters.sortOrders">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.sensorType">{{scope.row.sensorType}}</span>
          </template>
        </el-table-column>
        <el-table-column label="传感器名称" min-width="100px" :sortable="filters.sortable" prop="sensor_name" :sort-orders="filters.sortOrders">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.sensorName">{{scope.row.sensorName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="传感器编号" min-width="100px" :sortable="filters.sortable" prop="device_no" :sort-orders="filters.sortOrders">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.deviceNo">{{scope.row.deviceNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最小阈值(%)" min-width="100px" :sortable="filters.sortable">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.minThreshold">{{scope.row.minThreshold}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最大阈值(%)" min-width="100px">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row.maxThreshold">{{scope.row.maxThreshold}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="最小量程" min-width="120px">-->
<!--          <template v-slot="scope">-->
<!--            <span style="white-space: nowrap;" :title="scope.row.gasMinRange">{{scope.row.gasMinRange}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="最大量程" min-width="50px">-->
<!--          <template v-slot="scope">-->
<!--            <span style="white-space: nowrap;" :title="scope.row.gasMaxRange">{{scope.row.gasMaxRange}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button-group>
              <span  class="el-icon-edit" size="mini" @click="()=>{editRow(scope.row, scope.$index)}" trigger="click"  title="编辑"> 编辑</span>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <Pagination
          :currentPage="pagination.currentPage"
          :total="pagination.total"
          :pageSize="pagination.limit"
          @handleSizeChangeSub="handleSizeChangeSub"
          @handleCurrentChangeSub="handleCurrentChangeSub"
      />

      <!-- 新增气体 -->
      <GasInfoDialog ref="gasInfoDialog" :visibleFlag="true" :gasTypes="gasTypes" @setTotal="setTotal" @setRow="setRow"/>

      <!--查询工具条-->
      <el-col>
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item>查询条件：</el-form-item>
          <el-form-item prop="sensorTypeId">
            <el-select v-model="filters.sensorTypeId" placeholder="请选择传感器类型" clearable @change="researchSensor">
              <el-option v-for="item in gasTypes" :key="item.sensorTypeId" :label="item.sensorType" :value="item.sensorTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="keyword">
            <el-input v-model="filters.keyword" placeholder="请输入传感器名称" clearable @keyup.enter.native="researchsensor" :style="{width: '300px'}">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="researchSensor"></i>
            </el-input>
          </el-form-item>
          <el-form-item class="fixed-item-box" style="position: absolute;top: 9px;right: 10px;z-index: 3;margin: 0;">
            <el-dropdown split-button type="primary"  @click="add" trigger="click" size="mini">
              <i class="el-icon-circle-plus-outline"></i> 新增传感器
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item  icon="el-icon-delete" @click.native="deleteBatch">批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-form>
      </el-col>

    </section>
  </div>
</template>

<script>
  // 公共参数
  import GlobalParam from '@/global/global-param'
  // 弹框组件
  import GasInfoDialog from './GasInfoDialog'
  // 分页组件
  import Pagination from '@/components/Pagination.vue'
  // 气体组件
  import ApiGas from '@/request/api-gas'

export default {
  name: "GasInfoTable",
  /**
   * @Description 组件引用
   * @Date 16:58 2022/10/21
   * @Param
   * @Return
   */
  components: {
    // 标签弹出层组件
    GasInfoDialog,
    // 分页工具
    Pagination,
  },
  props: {
    gasTypes: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      // 公共参数
      GlobalParam: GlobalParam,
      /**
       * @Des 查询条件属性
       * @Auth jsh
       * @Date 09:41 2021/6/28
       */
      filters: {
        keyword: '',
        sensorType: '',
        sensorTypeId: '',
        orderBy: {
          "createTime": "asc"
        },
        sortOrders: [
          "ascending",
          "descending"
        ],
        sortable: 'custom',
      },
      // 气体信息集合
      sensorInfos:[],
      locked: false,
      speeds: ['110K', '850K', '6.81M'],
      channelNumbers: [2,5],
      /**
       * @Des 分页数据
       * @Auth
       * @Date 2021/6/4
       */
      pagination:{
        total: 0,
        startNum: 0,
        limit: 50,
        currentPage: 1
      },
      /**
       * 样式修改
       * */
      surroundSpan(value) {
        return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
      },
    }
  },
  computed: {
  },
  created(){

  },
  mounted(){
    // 查询气体
    this.searchSensorInfo();
  },
  /**
   * @Description 方法定义
   * @Date 17:00 2022/10/21
   * @Param
   * @Return
   */
  methods: {

    /**
     * @Description 查询气体信息
     * @Date 17:18 2022/10/21
     * @Param
     * @Return
     */
    searchSensorInfo() {
      this.$request.postJsonRequest(ApiGas.searchSensorApi, {
        keyword: this.filters.keyword,
        sensorTypeId: this.filters.sensorTypeId,
        orderBy: this.filters.orderBy,
        total: this.pagination.total,
        startNum: this.pagination.startNum,
        limit: this.pagination.limit,
      }).then(result => {

        this.sensorInfos = [];
        this.pagination.total = result.total;
        this.sensorInfos = result.rows;

      }).catch(error => {
        console.error('查询气体异常', ApiGas.searchSensorApi, error);
      })
    },
    /**
     * @Description 重新搜索
     * @Date 17:54 2022/10/21
     * @Param
     * @Return
     */
    researchSensor(){
      this.pagination.total = 0;
      this.pagination.startNum = 0;
      this.pagination.currentPage = 1;
      this.searchSensorInfo();
    },
    /**
     * @Description 改变排序
     * @Date 17:55 2022/10/21
     * @Param
     * @Return
     */
    changeSort(data){
      let prop = data.prop;
      let order = data.order;
      if(order == null){
        order = this.filters.orderBy[prop];
      }else{
        order = order.replace("ending", "");
      }
      if(order == null){
        this.filters.orderBy["sensorName"] = "asc";
      }else{
        this.filters.orderBy = {};
        this.filters.orderBy[prop] = order;
      }
      this.researchSensorInfo();
    },
    /**
     * @Description 当前页数据改变
     * @Date 17:57 2022/10/21
     * @Param
     * @Return
     */
    handleCurrentChangeSub(val){
      this.pagination.currentPage = val;
      this.pagination.startNum = this.pagination.limit * (val-1);
      this.searchSensorInfo();
    },
    /**
     * @Description 页长度改变
     * @Date 17:56 2022/10/21
     * @Param
     * @Return
     */
    handleSizeChangeSub(val){
      this.pagination.limit = val;
      this.pagination.currentPage = 1;
      this.pagination.startNum = 0;
      this.searchSensorInfo();
    },
    /**
     * @Description 添加气体
     * @Date 17:57 2022/10/21
     * @Param
     * @Return
     */
    add() {
      this.$refs.gasInfoDialog.openDialog('新增气体', '保存添加', 'add');
    },
    /**
     * @Description 修改气体
     * @Date 18:11 2022/10/21
     * @Param
     * @Return
     */
    editRow(row, index) {
      this.$refs.gasInfoDialog.openDialog('编辑气体', '保存修改', 'edit', row, index);
    },
    /**
     * @Description 批量删除
     * @Date 16:52 2022/10/22
     * @Param 
     * @Return 
     */
    deleteBatch() {
      let data = this.$refs.multipleTable.selection;
      const ids = [];
      data.forEach((row, index) => {
        ids.push(row.sensorId);
      })
      if(ids.length == 0){
        this.$message({
          message: '请选择要删除的数据！',
          type: 'warning',
          showClose: true,
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      this.$confirm(
          '确认批量删除气体吗？','询问',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal : false,
            type: 'warning'
          }
      ).then(_ => {
        // 删除账户 交互
        this.requestDelete(ids);
      }).catch(_ => {
        //console.log('cancel')
      });
    },

    /**
     * @Description 改变总数
     * @Date 10:30 2022/10/22
     * @Param
     * @Return
     */
    setTotal(val){
      this.pagination.total = val;
      if(val == 0){
        this.pagination.currentPage = 1;
        this.pagination.startNum = 0;
      }
      // 查询list
      this.searchSensorInfo();
    },
    /**
     * @Description 更新列表
     * @Date 10:30 2022/10/22
     * @Param
     * @Return
     */
    setRow(row, index){
      this.sensorInfos[index].sensorId = row.sensorId;
      this.sensorInfos[index].sensorTypeId = row.sensorTypeId;
      this.sensorInfos[index].sensorTypeId = row.sensorTypeId;
      this.sensorInfos[index].sensorType = row.sensorType;
      this.sensorInfos[index].sensorName = row.sensorName;
      this.sensorInfos[index].deviceNo = row.deviceNo;
      this.sensorInfos[index].minThreshold = row.minThreshold;
      this.sensorInfos[index].maxThreshold = row.maxThreshold;
      // this.sensorInfos[index].gasMinRange = row.gasMinRange;
      // this.sensorInfos[index].gasMaxRange = row.gasMaxRange;
    },
    /**
     * @Description 删除气体
     * @Date 18:12 2022/10/21
     * @Param
     * @Return
     */
    deleteRow(row, index) {
      this.$confirm(
          '确认删除【'+ row.sensorName +'】？','询问',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal : false,
            type: 'warning'
          }
      ).then(_ => {
        // 删除账户 交互
        this.requestDelete([row.sensorId]);
      }).catch(_ => {
        //console.log('cancel')
      });
    },
    /**
     * @Description 删除气体 交互
     * @Date 18:13 2022/10/21
     * @Param
     * @Return
     */
    requestDelete(sensorIds) {

      this.$request.postJsonRequest(ApiGas.deleteSensorApi,{
        sensorIds: sensorIds,
      }).then(result => {
        if(result.code == 0){
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            dangerouslyUseHTMLString: true
          });
          // 改变总数
          this.setTotal(0);

        }
      }).catch(error => {
        console.error('删除气体异常', ApiGas.deleteSensorApi, error);
      })
    },

  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_pages/gas/GasInfoTable.vue